import React from 'react';
import Icon from '../Common/Icon';
import group from '../../images/side-bar.jpg';
import ghost from '../../images/side-bar-ghost.png';
import './SideColumn.scss';

export default class SideColumn extends React.Component {

    render () {
        return (
            <div className="side-column">
                <img className='side-column-image' src={group} alt="EH Solution" width="100%" />
                <div className="content">
                    <div>
                        <div className="purp">Put your entire portfolio on the path to success with Pacer.</div>
                        <div className="mb-4 mt-4">Discover how easy and reliable it is for multi-location businesses to connect people, locations, and projects in real-time to respond to business needs rapidly.</div>
                        <div className="mb-4">
                            <img src={ghost} alt="EH Solution" width="220" />
                        </div>
                        <div className="mb-2">Discover the many uses of Pacer</div>
                        <div className="mb-4">
                            <div id="carouselExampleSlidesOnly" className="carousel slide" data-ride="carousel">
                                <div className="carousel-inner">
                                    <div className="carousel-item active" data-interval="3000">
                                        <div>Pre Openings Checklists + Transitions</div>
                                        <div>Sale Initiatives + Marketing Campaigns</div>
                                    </div>
                                    <div className="carousel-item" data-interval="3000">
                                        <div>New Menu Rollouts + Changes</div>
                                        <div>SOP Implementations</div>
                                    </div>
                                    <div className="carousel-item" data-interval="3000">
                                        <div>IT + Software Installations</div>
                                        <div>Annual Budget Planning</div>
                                    </div>
                                    <div className="carousel-item" data-interval="3000">
                                        <div>Property Improvement Plans</div>
                                        <div>HR Programs</div>
                                    </div>
                                    <div className="carousel-item" data-interval="3000">
                                        <div>Store Redesigns + Remodels</div>
                                        <div>Health Protocols</div>
                                    </div>
                                    <div className="carousel-item" data-interval="3000">
                                        <div>New Procedures</div>
                                        <div>Due Diligence</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mb-4">
                            <a href="https://getpacer.com" target="_blank" rel="noopener noreferrer">
                                <div className="pacer-button">
                                    Learn More<span><Icon name="arrow-right" /></span>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div>
                        <div className='mb-4 purp'>Refer Pacer and Earn $$</div>
                        <div className='mb-4'>Can your company, or someone you know, benefit from using Pacer&apos;s task management platform?</div>
                        <a href="https://www.getpacer.com/referral/" target="_blank" rel="noopener noreferrer">
                            <div className="pacer-button">
                                Refer Here<span><Icon name="arrow-right" /></span>
                            </div> 
                        </a>
                    </div>
                </div>
            </div>
        )    
    }
}